import { oc } from '@orpc/contract';
import { dashboardStatsOutputSchema } from '../schemas/dashboard.schemas.js';
/** Aggregates computed in SQL (plan §5.7), never by loading rows into the service. */
export const getDashboardStatsContract = oc
    .route({
    method: 'GET',
    path: '/dashboard/stats',
    tags: ['Dashboard'],
    summary: 'The workspace counters',
})
    .output(dashboardStatsOutputSchema);
//# sourceMappingURL=get-dashboard-stats.contract.js.map